import { createAction, createReducer, Dispatch } from '@reduxjs/toolkit';
import User from 'types/User';
import fetchAutolistUserUseCase from 'lib/UseCases/fetchAutolistUser';
import captureException from 'lib/captureException';

const signedIn = createAction<User>('auth/signedIn');
const userDataReceived = createAction<any>('auth/userData');

export function fetchAutolistUser() {
  return async function autolistUserFetcher(dispatch: Dispatch<any>): Promise<void> {
    try {
      const userData = await fetchAutolistUserUseCase();
      dispatch(userDataReceived(userData));
    } catch (e) {
      captureException(e);
    }
  };
}

const userReducer = createReducer(
  {},
  {
    [signedIn.type]: (state, action) => {
      return { ...state, ...action.payload };
    },
    [userDataReceived.type]: (state, action) => {
      return { ...state, ...action.payload };
    },
  }
);

export { signedIn, userReducer, userDataReceived };
